import queryString from 'query-string'

const REG = /^beastapp:\/\/(\S+)[\?\/]([\S\s]+)/i

const route = {
  'index': '/pages/index/index',
  // 'shop': '/shop?shopId=',
  'brand': '/pages/list/index?',
  'cate': '/pages/list/index?',
  'search': '/pages/list/index?',
  // 'retail': '/retail?',
  'product': `/pages/product/detail/detail?code=`,
  'article': `/pages/article/index?articleId=`,
  // 'customization-list': `/customization/list?`,
  // 'big-furniture-tips': '/furniture/tips?',
  // 'shop-story': '/shop/story?',
  'group-purchase': '/pages/group-purchase/index?',
  'points-benefit': '/pages-two/points-benefit/index?',
  'points-mall': '/pages-two/points-list/index?',
  'points-list': '/pages-two/points-list/index?',
  'points-coupon': '/pages-two/points-coupon/index?',
  'points-detail': '/pages-two/points-product/detail/detail?productCode=',
  'category': '/pages/category/index?',
  'store': '/pages/store/index?',
  'cart': '/pages/cart/cart?',
  'member': '/pages/my/member?',
  'my': '/pages/my/member?',
  'member-speed': '/member/speed?',
  'flower-list': '/flower/list?'
}

const params = {
  'brand': 'brandId'
}

export function transformMiniLink ({ link = {}, title = ''}) {
  if(!link.type) {
    return ''
  }
  let url = ""
  let tabFlag = false
  title = encodeURIComponent(title)
  switch (link.type) {
    case 'none':
      return ''
      break;
    case 'product':
      url = `/pages/product/detail/detail?code=${link.value}`
      break;
    case 'article':
      url = `/pages/article/index?articleId=${link.value}`
      break;
    case 'list':
      url = `/pages/list/index?listId=${link.value}&title=${title}`
      break;
    case 'new':
      url = `/pages/list/index?new=1&title=${title}`
      break;
    case 'all':
      url = `/pages/list/index?title=${title}`
      break;
    case 'oversea':
      url = `/pages/list/index?overseasOnly=true`
      break;
    case 'brand':
      url = `/pages/list/index?brandId=${link.value}&title=${title}`
      break;
    case 'tag':
      url = `/pages/list/index?labelId=${link.value}&title=${title}`
      break;
    case 'category':
      url = `/pages/list/index?categoryId=${link.value}`
      break;
    case 'discount':
      url = `/pages/list/index?param=discount&title=${encodeURIComponent('折扣')}`
      break;
    case 'campaign':
      url = `/pages/list/index?campaignCode=${link.value}&title=${title}`
      break;
    case 'shop-story':
      url = `/pages/shop-story/index?shopId=${link.value}`
      break;
    case 'group':
      url = `/pages/group-purchase/index?productId=${link.value}`
      break;
    case 'bu':
      let query = ""
      const idArr = link.value.split("-")
      if(!idArr.length) {
        return
      }
      if(idArr.length === 2 && idArr[1]) {
        query = `buId=${idArr[0]}&categoryId=${idArr[1]}&title=${title}`
      } else {
        query = `buId=${idArr[0]}&title=${title}`
      }
      
      url = `/pages/list/index?${query}`
      break;
    case 'program':
      url = link.value
      tabFlag = formatProgramLink(url)
      break;
    case 'deeplink':
      // url = dealMLink(link.value)
      // tabFlag = formatProgramLink(url)
      url = link.value //如果是/pages页面 要么直接跳转 要么小程序打开
      tabFlag = formatProgramLink(url)
      if (/^http/.test(url)) { // webview
        url = `/pages/web/index?url=${btoa(encodeURIComponent(url))}`
      } else if (/^beastapp/.test(url)) { // webview
        // console.log(url, '#########')
        url = dealMLink(url)
        tabFlag = formatProgramLink(url)
      }
      break;
    case 'selfdefine':
      url = link.weapp
      tabFlag = formatProgramLink(url)
      break;
  }

  console.log(url)
  if(tabFlag) {
    return {
      url,
      type: 'tab'
    }
  } else {
    return {
      url
    }
  }
  
}

function formatProgramLink (link) {
  if(!link) {
    return ''
  }

  const path = [
    "pages/index/index",
    "pages/category-v2/index",
    "pages/store/index",
    "pages/cart/cart",
    "pages/my/member/index",
    "pages/funny/index",
  ]

  let tabFlag = false
  path.some(p => {
    if(link.indexOf(p) !== -1) {//存在
      tabFlag = true
    }
  })

  return tabFlag

  // const FileSystemManager = wx.getFileSystemManager()
  // FileSystemManager.readFile({
  //   // filePath: '../app.json',
  //   filePath: wx.env.USER_DATA_PATH + '/app.json',
  //   success: function(res) {
  //     console.log(res, "**************")
  //   },
  //   fail: function(fail) {
  //     console.log(fail, "%%%%%%%%%%%%")
  //   }
  // })


}

function dealMLink (link) {
  console.log(link)
  if (link === 'beastapp://index') {
    link = '/pages/index/index'
  }
  else if (link === 'beastapp://my') {
    link = '/pages/my/member/index'
  }
  else {
    link = splitQue(link)
  }

  return link
}

function splitQue (query) {
  let que = REG.exec(query)
  let type = que[1]
  let search = que[2]
  let name = ''
  // entry
  if (type === 'entry') {
    type = queryString.parse(search).name
  }

  if (type && search) {
    que = matchQue(type, search)
  }

  return que
}

function matchQue (type, query) {
  let que = ''
  type = type.split('/')

  const path = route[type[0]]
  const pid = params[type[0]]

  if (path) {
    que = type[1] && pid
      ? `${path}${pid}=${type[1]}&${query}`
      : pid
        ? `${path}${pid}=${query}`
        : `${path}${query}`
  } else {
    que = `/${type[0].replace('-', '/')}`
  }

  return que
}



// WEBPACK FOOTER //
// ./static/link/mini-link.js